<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="apps"
    :items-per-page="10"
    class="elevation-1"
  >
    <template v-slot:item="props">
      <tr @click="onAppItemClick(props.item.id)">
        <td>{{ props.item.name }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    apps: {
      type: Array,
      required: true
    }
  },
  components: {},
  data: function() {
    return {
      selected: [],
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'name'
        }
      ]
    }
  },
  methods: {
    onAppItemClick(itemId) {
      this.$router.push('/app/' + itemId).catch(err => {})
    }
  }
}
</script>

<style scoped></style>
